import { event } from 'vue-gtag'

import i18n from '@/i18n/i18n'
import UserService from '@/services/retailer/UserService.js'

import { errorMessage } from '@/utilities/helpers'

import { USER_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const namespaced = true

export const state = {
  users: [],
  user: {},
  meta: null
}
export const mutations = {
  SET_USERS(state, users) {
    state.users = users.data
    state.meta = users.meta
  },
  SET_USER(state, user) {
    state.user = user
  },
  UPDATE_USER(state, user) {
    state.user = user
  },
  ADD_USER(state, user) {
    state.users.push(user)
  }
}

export const getters = {
  getUser: state => {
    return state.user
  },
  getUsers: state => {
    return state.users
  },
  getUserById: state => id => {
    return state.users ? state.users.find(user => user.id === id) : false
  }
}

export const actions = {
  editAccountUser({ commit, dispatch, rootState }, user) {
    return new Promise((resolve, reject) => {
      let retailerUser = rootState.retailerAuth.user
      UserService.editUser(retailerUser.id, user)
        .then(response => {
          commit('UPDATE_USER', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.data_updated')
          }

          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.data_update_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editAccountPassword({ dispatch, rootState }, password) {
    return new Promise((resolve, reject) => {
      let retailerUser = rootState.retailerAuth.user
      UserService.editPassword(retailerUser.id, password)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', { element: t('views.retailer.account.password') })
          }

          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getUser: function ({ commit, state }, id) {
    if (state.user.id && id === state.user.id) {
      return state.user
    }
    return new Promise((resolve, reject) => {
      UserService.getUser(id)
        .then(response => {
          commit('SET_USER', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getUsers({ commit }, query) {
    return new Promise(resolve => {
      UserService.getUsers(query)
        .then(response => {
          commit('SET_USERS', response)
          resolve(response)
        })
        .catch(err => {
          throw err
        })
    })
  },
  createUser({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      UserService.createUser(user)
        .then(response => {
          commit('ADD_USER', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.created', { element: t('views.retailer.users.index.new_user') })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editUser({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      UserService.editUser(params.id, params.user)
        .then(response => {
          commit('UPDATE_USER', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.data_updated')
          }

          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteUser({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      UserService.deleteUser(params.id)
        .then(response => {
          event('user_actions', {
            event_action: 'user_deleted'
          })
          commit('SET_USERS', response)
          const notification = {
            type: 'success',
            message: t('store.shared.deleted', { element: t('views.admin.applications.index.filters.applicant_id') })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: USER_ERROR_MESSAGES.deleteUserError + errorMessage(err)
          }
          event('error', {
            request_type: 'retailer_delete_user',
            error_message: notification
          })
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  validatePassword({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      UserService.validatePassword(user)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  markNotificationsAsRead({ commit, dispatch }, userId) {
    return new Promise((resolve, reject) => {
      UserService.markAsReadNotifications(userId)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
